module.exports = __webpack_public_path__ + "img/add_booking_dark_icon.a3c0e8b9.svg";